import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Tab, Tabs } from 'react-bootstrap';
import BasicInfoTab from '../components/profile/basicInfoTab';
import PasswordTab from '../components/profile/passwordTab';
import PermisesTab from '../components/profile/permisesTab';

function Profile() {

	//let authUser: AuthUser = useAppSelector(selectUser);
	//const username = localStorage.getItem("username")
	const auth = JSON.parse(localStorage.getItem('auth')!)

	return (
		<Container className='mt-4'>
			<h1 className='mb-0'>Profile</h1>
			<Row className='mb-3'>
				<Col lg="6"><p className='color-light'>Premise Address: {auth?.location?.BuildingNumber} {auth?.location?.BuildingName} {auth.location?.Floor ? 'Floor ' + auth?.location?.Floor : null} {auth?.location?.StreetAddress} {auth?.location?.City} {auth?.location?.ZipCode} </p></Col>
				<Col lg="6" className='text-lg-end text-start'><small className='color-light'>Last updated 30 mins ago</small></Col>
			</Row>

			<Row className='mt-4'>
				<Col>
					<Tabs
						defaultActiveKey="basicInfo"
						id="profileTabs"
					>
						<Tab eventKey="basicInfo" title="Basic info">
							<BasicInfoTab />
						</Tab>
						<Tab eventKey="password" title="Password">
							<PasswordTab />
						</Tab>
						<Tab eventKey="premise " title="Premise ">
							<PermisesTab />
						</Tab>
						{/* <Tab eventKey="device " title="Device ">
							<DevicesTab />
						</Tab> */}
					</Tabs>
				</Col>
			</Row>
		</Container>
	);
}
export default Profile;
